import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { FlatButton, Slider, Toggle, SelectField, Popover, MenuItem } from 'material-ui';
var TemplateConstants = require('../TemplateConstants.js');

class Component extends React.PureComponent {
    state = {};

    render() {
        const { layer, expanded, anchorEl, isTeamColor } = this.props;

        const properyChange = obj => {
            this.props.onProperyChange(obj);
            this.forceUpdate();
        };

        if (isTeamColor) {
            return (
                <Popover open={expanded} anchorEl={anchorEl}>
                    <div style={{ padding: 16, width: 400 }}>
                        <div className="customizer-label">Opacity</div>
                        <Slider
                            step={0.01}
                            min={0.1}
                            max={1}
                            key="Opacity"
                            value={layer.opacity}
                            sliderStyle={{
                                marginBottom: '0px',
                                marginTop: '12px',
                            }}
                            onChange={(e, opacity) => {
                                properyChange({ opacity });
                            }}
                        />
                    </div>
                    <FlatButton
                        label="Reset"
                        onClick={() => {
                            properyChange(
                                _.extend(TemplateConstants.LAYER, { backgroundImage: layer.backgroundImage }),
                            );
                        }}
                    />

                    <FlatButton label="Done" onClick={this.props.onDoneClick} />
                </Popover>
            );
        }

        return (
            <Popover open={expanded} anchorEl={anchorEl}>
                <div style={{ padding: 16, width: 400 }}>
                    <SelectField
                        floatingLabelText="Horizontal"
                        value={layer.backgroundSize}
                        key="backgroundSize"
                        style={{ width: '100%' }}
                        onChange={(e, index, backgroundSize) => {
                            properyChange({ backgroundSize });
                        }}
                    >
                        <MenuItem key="c2" value="contain" primaryText="Contain image in widget" />
                        <MenuItem key="c1" value="cover" primaryText="Cover whole widget" />
                        <MenuItem key="c3" value="initial" primaryText="Image original" />
                    </SelectField>

                    <Toggle
                        label="Top Overlay"
                        defaultToggled={layer.topOverlay === true}
                        onToggle={(e, isInputChecked) => {
                            properyChange({
                                topOverlay: isInputChecked,
                            });
                        }}
                    />
                    {layer.backgroundSize === 'contain' || layer.backgroundSize === 'initial'
                        ? [
                              <SelectField
                                  floatingLabelText="Horizontal"
                                  value={layer.backgroundPositionX}
                                  key="backgroundPositionX"
                                  style={{ width: 150 }}
                                  onChange={(e, index, backgroundPositionX) => {
                                      properyChange({ backgroundPositionX });
                                  }}
                              >
                                  {_.compact([
                                      'center',
                                      'left',
                                      'right',
                                      layer.backgroundSize === 'contain' && 'moveX',
                                  ]).map(o => {
                                      return <MenuItem key={o} value={o} primaryText={o} />;
                                  })}
                              </SelectField>,
                              <SelectField
                                  floatingLabelText="Vertical"
                                  value={layer.backgroundPositionY}
                                  key="backgroundPositionY"
                                  style={{ width: 150 }}
                                  onChange={(e, index, backgroundPositionY) => {
                                      properyChange({ backgroundPositionY });
                                  }}
                              >
                                  {_.compact([
                                      'center',
                                      'top',
                                      'bottom',
                                      layer.backgroundSize === 'contain' && 'moveY',
                                  ]).map(o => {
                                      return <MenuItem key={o} value={o} primaryText={o} />;
                                  })}
                              </SelectField>,

                              layer.backgroundPositionX === 'moveX' && <div className="customizer-label">Move X</div>,
                              layer.backgroundPositionX === 'moveX' && (
                                  <Slider
                                      step={1}
                                      min={-1000}
                                      max={1000}
                                      key="translateX"
                                      value={layer.translateX}
                                      sliderStyle={{
                                          marginBottom: '0px',
                                          marginTop: '12px',
                                      }}
                                      onChange={(e, translateX) => {
                                          properyChange({ translateX });
                                      }}
                                  />
                              ),
                              layer.backgroundPositionY === 'moveY' && <div className="customizer-label">Move Y</div>,
                              layer.backgroundPositionY === 'moveY' && (
                                  <Slider
                                      step={1}
                                      min={-1000}
                                      max={1000}
                                      key="translateY"
                                      value={layer.translateY}
                                      sliderStyle={{
                                          marginBottom: '0px',
                                          marginTop: '12px',
                                      }}
                                      onChange={(e, translateY) => {
                                          properyChange({ translateY });
                                      }}
                                  />
                              ),
                          ]
                        : [
                              <div className="customizer-label">Move X (if landscape)</div>,
                              <Slider
                                  step={1}
                                  min={0}
                                  max={100}
                                  key="translateX"
                                  value={layer.translateX}
                                  sliderStyle={{
                                      marginBottom: '0px',
                                      marginTop: '12px',
                                  }}
                                  onChange={(e, translateX) => {
                                      properyChange({ translateX });
                                  }}
                              />,
                              <div className="customizer-label">Move Y (if portrait)</div>,
                              <Slider
                                  step={1}
                                  min={0}
                                  max={100}
                                  key="translateY"
                                  value={layer.translateY}
                                  sliderStyle={{
                                      marginBottom: '0px',
                                      marginTop: '12px',
                                  }}
                                  onChange={(e, translateY) => {
                                      properyChange({ translateY });
                                  }}
                              />,
                          ]}

                    {layer.backgroundSize === 'contain' && (
                        <div>
                            <div className="customizer-label">Scale/Zoom</div>

                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <Slider
                                    step={0.01}
                                    min={0.1}
                                    max={10}
                                    key="Scale"
                                    value={layer.scale}
                                    sliderStyle={{
                                        marginBottom: '0px',
                                        marginTop: '12px',
                                        marginRight: 10,
                                        width: 200,
                                    }}
                                    onChange={(e, scale) => {
                                        properyChange({ scale });
                                    }}
                                />
                                <FlatButton
                                    label="Zoom: 1.0"
                                    onClick={() => {
                                        properyChange({ scale: 1.0 });
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    <div className="customizer-label">Opacity</div>
                    <Slider
                        step={0.01}
                        min={0.1}
                        max={1}
                        key="Opacity"
                        value={layer.opacity}
                        sliderStyle={{
                            marginBottom: '0px',
                            marginTop: '12px',
                        }}
                        onChange={(e, opacity) => {
                            properyChange({ opacity });
                        }}
                    />

                    <div
                        style={{
                            margin: '16px -16px',
                            height: 1,
                            background: '#666',
                        }}
                    />

                    <FlatButton
                        label="Reset"
                        onClick={() => {
                            properyChange(
                                _.extend(TemplateConstants.LAYER, { backgroundImage: layer.backgroundImage }),
                            );
                        }}
                    />

                    <FlatButton label="Done" onClick={this.props.onDoneClick} />
                </div>
            </Popover>
        );
    }
}

export default Component;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/templates/editor/ImageManipulationsDialogue.js
 **/